module.exports = __webpack_public_path__ + "static/media/longterm-orig.f5252999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/longterm-orig.jpg
// module id = 408
// module chunks = 0